// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__xcwFu","title":"styles_title__+ZTlH","visualizer":"styles_visualizer__6MbEs"};